<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '25vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
    rejectButtonStyleClass="p-button-text" styleClass="dark-confirm"></p-confirmDialog>
<p-confirmDialog [style]="{width: '25vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
    rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar dark-confirm"
    [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
    <div class="container-fluid" style="width: 90%;">
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card card-shadow sinborde">
                    <div class="card-header sinborde" style="background: none;">
                        <div class="cardicono rounded">
                            <i class="pi pi-calculator" style="color: #fff;"></i>
                        </div>
                        
                        <header class="posicion" style="left: 6%; top: 0%;">Usuarios de Comercial</header>
                        <button pButton class="justify-content-end" label="Nuevo Usuario" icon="pi pi-plus"
                            (click)="abrirModalAgregar()">
                            </button>
                    </div>
                    <div class="card-content">
                        
                        <div class="row mt-3">
                            <p-table #dt1 [value]="UsuariosComercial" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm p-datatable-striped"
                                dataKey="id_config_unidad" [rows]="10" 
                                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10]" [resizableColumns]="false"
                                [paginator]="true" responsiveLayout="scroll" 
                                currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} registros"
                                [globalFilterFields]="['nombre', 'apellido_paterno']">
                                                                                                <ng-template pTemplate="caption">
                                    <div class="flex">
                                        <div class="col-md-2">
                                            <button pButton label="Limpiar" class="p-button-outlined"
                                            icon="pi pi-filter-slash" (click)="limpiarFiltro()" (click)="clear(dt1)" >
                                            </button>
                                        </div>
                                        
                                        
                                        <div class="col-md-2">
                                            <p-columnFilter field="clv_activo" matchMode="contains" [showMenu]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <p-dropdown [ngModel]="value" [options]="objEstatus"
                                                        optionLabel="des_estatus" optionValue="clv_activo"
                                                        (onChange)="filter($event.value)"
                                                        placeholder="Filtrar por estatus" [showClear]="true">
                                                    </p-dropdown>
                                                </ng-template>
                                            </p-columnFilter>
                                        </div>
                                        <div class="col-md-2 search-col">
                                            <span class="ml-auto search-field">
                                                <i class="pi pi-search mover"></i>
                                                <input pInputText #filtroInput id="filtro" type="text"
                                                    (input)="applyFilterGlobal($event, 'contains')"
                                                    placeholder="Buscar Descripción" />
                                            </span>
                                        </div>
                                        
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr [ngClass]="{'texto_sm':true}">
                                        <th>#</th>
                                        <th style="min-width: 15rem">Nombre</th>
                                        <th style="min-width: 10rem">Correo</th>
                                        <th style="min-width: 10rem">celular</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-data let-index="rowIndex">
                                    <tr [ngClass]="{'row-accessories': data.clv_activo === 0}">
                                        <td>
                                            <div class="texto_negrita">{{(index + 1)}}</div>
                                        </td>
                                        <td class="texto_negrita texto_naranja_ba">
                                            <div class="texto_negrita"> 
                                                {{data.nombre+' '+data.apellido_paterno}}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="texto_negrita"> 
                                                {{data.correo}}
                                            </div>
                                        </td> 
                                        <td>
                                            <div class="texto_negrita"> 
                                                {{data.lada+' '+ data.celular}}
                                            </div>
                                        </td>        
                                        <td>
                                            <p-tag *ngIf="data.clv_estatus == 1" icon="pi pi-user" [rounded]="true" severity="success" value="Activo"></p-tag>
                                            <p-tag *ngIf="data.clv_estatus == 0" icon="pi pi-user" [rounded]="true" severity="warning" value="Desactivado"></p-tag>
                                        </td>
                                        <td style="width: 130px;">
                                            <div class="d-flex justify-content-around table-actions">
                                                <button class="btn btn-warning" pTooltip="Editar Informacion"
                                                     tooltipPosition="left" (click)="mostrarModalEditar(data);">
                                                    <i class="pi pi-pencil"></i>
                                                </button>
                                                <button class="btn btn-info" pTooltip="Cambiar Estatus"
                                                         tooltipPosition="top" (click)="confirmarDesactivar(data);">
                                                    <i class="pi pi-delete-left"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="13">No se encontró ningún registro.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog [(visible)]="dspAgregarUsuario" [style]="{width: '50vw'}" styleClass="dark-dialog">
        <ng-template pTemplate="header">
          <h3>Agregar Usuario Comercial</h3>
        </ng-template>
      
        <ng-template pTemplate="content">
          <form [formGroup]="UsuarioComercialForm" (ngSubmit)="guardarInformacion()">
            <div class="form-container">

                <div class="grid">
              
                  <!-- Nombre -->
                  <div class="col-12 md:col-6 field">
                    <label>Nombre</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-user"></i>
                      <input pInputText formControlName="nombre" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': f['nombre'].invalid && f['nombre'].touched}" />
                    </span>
                    <small class="error-text" *ngIf="f['nombre'].invalid && f['nombre'].touched">
                      El nombre es obligatorio
                    </small>
                  </div>
              
                  <!-- Apellido -->
                  <div class="col-12 md:col-6 field">
                    <label>Apellido</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-id-card"></i>
                      <input pInputText formControlName="apellido_paterno" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': f['apellido_paterno'].invalid && f['apellido_paterno'].touched}" />
                    </span>
                    <small class="error-text" *ngIf="f['apellido_paterno'].invalid && f['apellido_paterno'].touched">
                      El apellido es obligatorio
                    </small>
                  </div>
              
                  <!-- Correo -->
                  <div class="col-12 md:col-6 field">
                    <label>Correo</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-envelope"></i>
                      <input pInputText formControlName="correo" class="w-full" />
                    </span>
                  </div>
              
                  <div class="col-12 md:col-6 field">

                    <label>Teléfono</label>
                  
                    <div style="display: flex; gap: 10px;">
                  
                      <!-- LADA -->
                      <div style="width: 100px;">
                        <label class="sub-label">Lada</label>
                        <input 
                          pInputText 
                          formControlName="lada"
                          maxlength="3"
                          placeholder="+52"
                          class="w-full"
                          [ngClass]="{'ng-invalid ng-dirty': f['lada'].invalid && f['lada'].touched}" />
                      </div>
                  
                      <!-- CELULAR -->
                      <div class="w-full">
                        <label class="sub-label">Celular</label>
                        <input
                          pInputText
                          formControlName="celular"
                          placeholder="123-4567"
                          class="w-full"
                          [ngClass]="{'ng-invalid ng-dirty': f['celular'].invalid && f['celular'].touched}"/>
                      </div>
                  
                    </div>
                  
                    <!-- ERRORES -->
                    <small class="error-text"
                      *ngIf="f['lada'].invalid && f['lada'].touched">
                      Lada inválida
                    </small>
                  
                    <small class="error-text"
                      *ngIf="f['celular'].invalid && f['celular'].touched">
                      Número inválido
                    </small>
                  
                  </div>
              
                </div>
              
              </div>
          </form>
        </ng-template>
      
        <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-3 mt-3">

                <button 
                  pButton 
                  label="Guardar" [disabled]="UsuarioComercialForm.invalid"
                  icon="pi pi-save" (click)="guardarInformacion()"
                  class="p-button-success">
                </button>
              
                <button 
                  pButton 
                  label="Cancelar"
                  icon="pi pi-times" (click)="cancelarVentanaModal()"
                  class="p-button-text">
                </button>
              
              </div>
        </ng-template>
      </p-dialog>

      <p-dialog [(visible)]="dspEditarUsuario" [style]="{width: '50vw'}" styleClass="dark-dialog">
        <ng-template pTemplate="header">
          <h3>Editar Usuario Comercial</h3>
        </ng-template>
      
        <ng-template pTemplate="content">
          <form [formGroup]="UsuarioComercialForm">
      
            <div class="form-container">

                <div class="grid">
              
                  <!-- Nombre -->
                  <div class="col-12 md:col-6 field">
                    <label>Nombre</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-user"></i>
                      <input pInputText formControlName="nombre" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': f['nombre'].invalid && f['nombre'].touched}" />
                    </span>
                    <small class="error-text" *ngIf="f['nombre'].invalid && f['nombre'].touched">
                      El nombre es obligatorio
                    </small>
                  </div>
              
                  <!-- Apellido -->
                  <div class="col-12 md:col-6 field">
                    <label>Apellido</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-id-card"></i>
                      <input pInputText formControlName="apellido_paterno" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': f['apellido_paterno'].invalid && f['apellido_paterno'].touched}" />
                    </span>
                    <small class="error-text" *ngIf="f['apellido_paterno'].invalid && f['apellido_paterno'].touched">
                      El apellido es obligatorio
                    </small>
                  </div>
              
                  <!-- Correo -->
                  <div class="col-12 md:col-6 field">
                    <label>Correo</label>
                    <span class="p-input-icon-left w-full">
                      <i class="pi pi-envelope"></i>
                      <input pInputText formControlName="correo" class="w-full" />
                    </span>
                  </div>
              
                  <div class="col-12 md:col-6 field">

                    <label>Teléfono</label>
                  
                    <div class="flex gap-2">
                  
                      <!-- LADA -->
                      <div style="width: 100px;">
                        <label class="sub-label">Lada</label>
                        <input 
                          pInputText 
                          formControlName="lada"
                          maxlength="3"
                          placeholder="667"
                          class="w-full"
                          [ngClass]="{'ng-invalid ng-dirty': f['lada'].invalid && f['lada'].touched}" />
                      </div>
                  
                      <!-- CELULAR -->
                      <div class="w-full">
                        <label class="sub-label">Celular</label>
                        <input
                          pInputText
                          formControlName="celular"
                          placeholder="123-4567"
                          class="w-full"
                          [ngClass]="{'ng-invalid ng-dirty': f['celular'].invalid && f['celular'].touched}"/>
                      </div>
                  
                    </div>
                  
                    <!-- ERRORES -->
                    <small class="error-text"
                      *ngIf="f['lada'].invalid && f['lada'].touched">
                      Lada inválida
                    </small>
                  
                    <small class="error-text"
                      *ngIf="f['celular'].invalid && f['celular'].touched">
                      Número inválido
                    </small>
                  
                  </div>
              
              
                </div>
              
              </div>
      
          </form>
        </ng-template>
      
        <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-3 mt-3">

                <button 
                  pButton (click)="EditarInformacion()" [disabled]="UsuarioComercialForm.invalid"
                  label="Guardar"
                  icon="pi pi-save"
                  class="p-button-success">
                </button>
              
                <button 
                  pButton 
                  label="Cancelar"
                  icon="pi pi-times" (click)="cancelarVentanaModal()"
                  class="p-button-text">
                </button>
              
              </div>
        </ng-template>
      </p-dialog>
</div>









